import { STAFF_PATHS } from '../utils/staffPaths';
import React from "react";
import { Navigate, useParams } from "react-router-dom";
import StaffLayout from "./StaffLayout";
import { DEFAULT_ADMIN_SECTION, findStaffItem } from "./staffNav";
import FeatureRequestBoard from "./FeatureRequestBoard";
import TenantsChart from "./Tenants";
import UpdateVersion from "./version";
import ScanModules from "./ScanModules";
import UnifiedLogs from "./UnifiedLogs";
import UserManagement from "./UserManagement";
import TemplateManagement from "./TemplateManagement";
import AdminCategoryThresholds from "./AdminCategoryThresholds";
import AISettings from "./AISettings";
import BillingSettings from "./BillingSettings";
import GhlSettings from "./GhlSettings";
import EntraSettings from "./EntraSettings";
import PasskeySettings from "./PasskeySettings";
import SmtpSettings from "./SmtpSettings";
import AdminAccessPolicy from "./AdminAccessPolicy";
// No longer used by this screen. Kept because CRA bundles every stylesheet into one global
// sheet and the v1 tenant dashboard (components/Dashboard.js) shares these class names, so
// dropping the import would quietly restyle v1.
import "./dashboard.css";

// Administration. Each section is its own address, /admin/dashboard/<slug> (staffNav.js),
// so it can be bookmarked, refreshed and reached with Back; the shell around it is the
// same StaffLayout as Marketing, Staff team and Settings.
const SECTIONS = {
    tenants: TenantsChart,
    plans: ScanModules,
    releases: UpdateVersion,
    templates: TemplateManagement,
    thresholds: AdminCategoryThresholds,
    users: UserManagement,
    logs: UnifiedLogs,
    "feature-requests": FeatureRequestBoard,
    ai: AISettings,
    billing: BillingSettings,
    gohighlevel: GhlSettings,
    microsoft: EntraSettings,
    passkeys: PasskeySettings,
    email: SmtpSettings,
    "access-policy": AdminAccessPolicy,
};

function AdminDashboard() {
    const { section } = useParams();
    const Screen = SECTIONS[section];
    // /admin/dashboard, and any slug that is not a section, lands on the default rather
    // than an empty page. replace, so Back does not bounce through the bare address.
    if (!Screen || !findStaffItem(section)) {
        return <Navigate to={`${STAFF_PATHS.dashboard}/${DEFAULT_ADMIN_SECTION}`} replace />;
    }
    return (
        <StaffLayout section={section} native={false}>
            <Screen />
        </StaffLayout>
    );
}

export default AdminDashboard;
